import React from 'react'
import Button from '@mui/material/Button'

export type Props = {
  label: string
  onClick: () => void
}

export const FormSettingsLink = ({ label, onClick }: Props) => (
  <Button
    sx={{
      color: '#1565C0',
      p: 0,
      minWidth: 0,
      verticalAlign: 'baseline',
      textTransform: 'none',
    }}
    variant="text"
    onClick={onClick}
    data-test-id="pending-lead-form-settings-link"
  >
    {label}
  </Button>
)

FormSettingsLink.displayName = 'FormSettingsLink'
